<template>
  <PopupBase
    :show="show"
    @close-pop-up="$emit('close-pop-up')"
    class="popup-oring-construction"
    :size="POPUP.Size.small"
  >
    <div class="popup-oring-construction__header">
      <h4>{{ title }}</h4>
    </div>
    <div class="popup-oring-construction__body">
      <ValidationForm
        @success="handleSubmit"
        :get-form="getForm"
        class="construction-form"
        :id="formId"
      >
        <div class="form-field form-field--horizontal">
          <label
            id="firstName-label"
            class="form-label"
            for="firstName"
          >
            {{ $tv('Frontend.TranslationContactFirstName', 'ORingConfiguratorImport') }}*
          </label>
          <InputText
            v-model="formData.firstName"
            type="text"
            name="firstName"
            :placeholder="$tv('Frontend.PdfDownload.Placeholder.FirstName', 'ORingConfigurator')"
            class="form-input"
            id="firstName"
            aria-labelledby="firstName-label"
            ref="validationFormFirstName"
            :rules="[requiredValidationRule(i18n.tv('Frontend.TranslationContactFirstName', 'ORingConfiguratorImport'))]"
          />
        </div>

        <div class="form-field form-field--horizontal">
          <label
            id="lastName-label"
            class="form-label"
            for="lastName"
          >
            {{ $tv('Frontend.TranslationContactLastName', 'ORingConfiguratorImport') }}*
          </label>
          <InputText
            v-model="formData.lastName"
            type="text"
            name="lastName"
            :placeholder="$tv('Frontend.PdfDownload.Placeholder.LastName', 'ORingConfigurator')"
            class="form-input"
            id="lastName"
            aria-labelledby="lastName-label"
            ref="validationFormLastName"
            :rules="[requiredValidationRule(i18n.tv('Frontend.TranslationContactLastName', 'ORingConfiguratorImport'))]"
          />
        </div>

        <div class="form-field form-field--horizontal">
          <label
            id="email-label"
            class="form-label"
            for="email"
          >
            {{ $tv('Frontend.PdfDownload.Label.EMail', 'ORingConfiguratorImport') }}*
          </label>
          <InputText
            v-model="formData.email"
            name="email"
            :placeholder="$tv('Frontend.PdfDownload.Placeholder.Email', 'ORingConfiguratorImport')"
            class="form-input"
            id="email"
            aria-labelledby="email-label"
            ref="validationFormEmail"
            :rules="[
              requiredValidationRule(i18n.tv('email', 'ORingConfigurator')),
              emailValidationRule(i18n.tv('email', 'ORingConfigurator'))
            ]"
          />
        </div>

        <div class="form-field form-field--horizontal">
          <label
            id="company-label"
            class="form-label"
            for="company"
          >
            {{ $tv('Frontend.PdfDownload.Label.Company', 'ORingConfiguratorImport') }}*
          </label>
          <InputText
            v-model="formData.company"
            type="text"
            name="company"
            :placeholder="$tv('Frontend.PdfDownload.Placeholder.Company', 'ORingConfiguratorImport')"
            class="form-input"
            id="company"
            aria-labelledby="company-label"
            ref="validationFormCompany"
            :rules="[requiredValidationRule(i18n.tv('Frontend.PdfDownload.Label.Company', 'ORingConfiguratorImport'))]"
          />
        </div>

        <div class="form-field form-field--horizontal">
          <label
            id="telephone-label"
            class="form-label"
            for="telephone"
          >
            {{ $tv('rfqPopupFormLabelPhone', 'partnerHub') }}
          </label>
          <InputText
            v-model="formData.telephone"
            type="text"
            name="telephone"
            :placeholder="$tv('rfqPopupFormPlaceholderPhone', 'partnerHub')"
            class="form-input"
            id="telephone"
            aria-labelledby="telephone-label"
            ref="validationFormTelephone"
          />
        </div>

        <div class="form-field form-field--horizontal form-field--country">
          <label
            id="country-label"
            class="form-label"
            for="country"
          >
            {{ i18n.tv('country', 'contactForm') }}*
          </label>
          <ComboDropDown
            v-model="formData.country"
            :data-items="countryOptions"
            text-field="text"
            data-item-key="value"
            value-field="value"
            :value-primitive="true"
            :filterable="true"
            name="country"
            class="form-input"
            id="country"
            aria-labelledby="country-label"
            ref="validationFormCountry"
            :rules="[requiredValidationRule(i18n.tv('country', 'contactForm'))]"
          />
        </div>

        <div
          v-if="!isLoggedIn"
          class="form-field form-field--horizontal"
        >
          <label
            id="industryType-label"
            class="form-label"
            for="industryType"
          >
            {{ $tv('rfqPopupFormLabelIndustry', 'partnerHub') }}*
          </label>
          <DropDown
            v-model="formData.industryType"
            :data-items="industryTypeOptions"
            text-field="text"
            data-item-key="value"
            value-field="value"
            :value-primitive="true"
            name="industryType"
            class="form-input"
            id="industryType"
            aria-labelledby="industryType-label"
            ref="validationFormIndustryType"
            :rules="!isLoggedIn ? [requiredValidationRule(i18n.tv('rfqPopupFormLabelIndustry', 'partnerHub'))] : []"
          />
        </div>

        <div
          v-if="showSpecificIndustry && !isLoggedIn"
          class="form-field form-field--horizontal"
        >
          <label
            id="specificIndustry-label"
            class="form-label"
            for="specificIndustry"
          >
            {{ $tv('rfqPopupFormLabelLeadMarket', 'partnerHub') }}*
          </label>
          <DropDown
            v-model="formData.specificIndustry"
            :data-items="specificIndustryOptions"
            text-field="text"
            data-item-key="value"
            value-field="value"
            :value-primitive="true"
            name="specificIndustry"
            class="form-input"
            id="specificIndustry"
            aria-labelledby="specificIndustry-label"
            ref="validationFormSpecificIndustry"
            :rules="showSpecificIndustry && !isLoggedIn ? [requiredValidationRule(i18n.tv('rfqPopupFormLabelLeadMarket', 'partnerHub'))] : []"
          />
        </div>

        <div class="form-field form-field--horizontal">
          <label
            id="pdfLanguage-label"
            class="form-label"
            for="pdfLanguage"
          >
            {{ $tv('Frontend.PdfDownload.DownloadLanguage', 'ORingConfiguratorImport') }}*
          </label>
          <DropDown
            v-model="formData.pdfLanguage"
            :data-items="pdfLanguageOptions"
            text-field="text"
            data-item-key="value"
            name="pdfLanguage"
            class="form-input"
            id="pdfLanguage"
            aria-labelledby="pdfLanguage-label"
            ref="validationFormPdfLanguage"
            :rules="[requiredValidationRule(i18n.tv('Frontend.PdfDownload.DownloadLanguage', 'ORingConfiguratorImport'))]"
          />
        </div>

        <div class="form-field form-field--horizontal">
          <label
            id="designRemarks-label"
            class="form-label"
            for="designRemarks"
          >
            {{ $tv('Frontend.PdfDownload.Label.DesignRemarks', 'ORingConfiguratorImport') }} {{ $tv('optional', 'simmerringSelector') }}
          </label>
          <textarea
            v-model="formData.designRemarks"
            name="designRemarks"
            :placeholder="$tv('Frontend.PdfDownload.Placeholder.DesignRemark', 'ORingConfiguratorImport')"
            class="k-textbox input k-textarea form-input textarea data-hj-allow"
            id="designRemarks"
            aria-labelledby="designRemarks-label"
          />
        </div>

        <div class="form-field form-field--horizontal checkbox">
          <Checkbox
            id="acceptTerms"
            v-model="formData.acceptTerms"
            :rules="[requiredCheckboxValidationRule(i18n.tv('privacyAgreement', 'ORingConfigurator'))]"
            name="acceptTerms"
            ref="validationFormAcceptTerms"
            :use-markdown="true"
            :label="acceptTermsLabel"
          />
        </div>

        <div
          v-if="submissionStatus === 'error'"
          class="submission-status error"
        >
          <AlertError class="error__icon" />
          <span> {{ statusMessage }} </span>
        </div>

        <div class="form-actions">
          <span>{{ i18n.tv('mandatoryFields', 'contactForm') }}</span>
          <ReactiveButton
            :button-text="submitButtonText"
            :is-loading="isSubmitting"
            :is-primary-button="false"
            :show-text-while-loading="true"
            class="submit-button"
            type="submit"
          />
        </div>
      </ValidationForm>
    </div>
  </PopupBase>
</template>

<script setup lang="ts">
import PopupBase from './PopupBase.vue'
import InputText from '~/components/input-components/InputText.vue'
import DropDown from '~/components/input-components/DropDown.vue'
import ComboDropDown from '~/components/input-components/ComboDropDown.vue'
import Checkbox from '~/components/input-components/Checkbox.vue'
import ReactiveButton from '~/components/ReactiveButton.vue'
import ValidationForm from '~/components/input-components/ValidationForm.vue'
import useI18nExtended from '~/composables/usei18nExtended'
import {ref, computed, watch} from 'vue'
import {useDynamicsLeadCapture} from '~/composables/useDynamicsLeadCapture'
import {useFormPrefill} from '~/composables/useFormPrefill'
import {useFormDropdowns} from '~/composables/useFormDropdowns'
import {useFormPrivacyText} from '~/composables/useFormPrivacyText'
import {generateFormId} from '~/utils/generateFormId'
import {
  requiredValidationRule,
  requiredCheckboxValidationRule,
  emailValidationRule
} from 'assets/js/validations/common_validation_rules'
import AlertError from '~/assets/icons/alert_error.svg?component'
import {POPUP} from '~/assets/js/constants'
import {useUserStore} from '@/store/user'

const app = useNuxtApp()

interface Props {
  show: boolean
  mode: 'download' | 'send'
  // eslint-disable-next-line no-unused-vars
  onSubmit?: (data: any) => Promise<void>
  initialData?: {
    firstName?: string
    lastName?: string
    company?: string
    email?: string
    designRemarks?: string
    pdfLanguage?: string | null
    acceptTerms?: boolean
    designName?: string
    parameters?: Record<string, any>
  }
}

const userStore = useUserStore()

// Check if user is logged in
const isLoggedIn = computed(() => userStore.loggedIn)

// ERP fields for logged-in users
const companyNo = computed(() => {
  if (!isLoggedIn.value) {return ''}
  return (userStore.selectedCustomer as any)?.customerNo || ''
})

const salesOrganization = computed(() => {
  if (!isLoggedIn.value) {return ''}
  const c = userStore.selectedCustomer as any
  if (!c?.salesOrg) {return ''}
  return `${c.salesOrg}-${c.salesChannel}-${c.distribution}`
})

const i18n = useI18nExtended()
const dynamicsCapture = useDynamicsLeadCapture()

// Import dropdown options and prefill utilities
const {getExtendedPrefillData} = useFormPrefill()
const {
  countryOptions,
  industryTypeOptions,
  specificIndustryOptions,
  limitedLanguageOptions,
  shouldShowSpecificIndustry
} = useFormDropdowns()
const {privacyPolicyText} = useFormPrivacyText()

const props = withDefaults(defineProps<Props>(), {
  show: false,
  mode: 'download',
  onSubmit: undefined,
  initialData: () => ({})
})

const emit = defineEmits<{
  'close-pop-up': []
  'submit': [data: any]
}>()

const isSubmitting = ref(false)
const submissionStatus = ref<'success' | 'error' | null>(null)
const statusMessage = ref('')

// Generate unique form ID
const formId = ref(generateFormId('oringConstructionForm'))

// Form data with extended prefilling from shared composable
const prefillData = getExtendedPrefillData()
const formData = ref({
  firstName: prefillData.firstName,
  lastName: prefillData.lastName,
  email: prefillData.email,
  company: prefillData.company,
  telephone: prefillData.phone,
  country: prefillData.country || null,
  industryType: (prefillData.industryType ? Number(prefillData.industryType) : null) as number | null,
  specificIndustry: (prefillData.specificIndustry ? Number(prefillData.specificIndustry) : null) as number | null,
  leadMarket: prefillData.leadMarket || null,
  pdfLanguage: null as string | null,
  designRemarks: '',
  acceptTerms: false
})

// PDF language options (limited to English and German)
const pdfLanguageOptions = computed(() => limitedLanguageOptions.value)

// Show specific industry dropdown (labeled as Lead Market) conditionally when Non-Automotive is selected
const showSpecificIndustry = computed(() => {
  return shouldShowSpecificIndustry(formData.value.industryType)
})

// Accept terms label with translated privacy policy text from composable
const acceptTermsLabel = privacyPolicyText

const title = computed(() => {
  return props.mode === 'download'
    ? i18n.tv('Frontend.Button.DownloadConstruction', 'ORingConfiguratorImport')
    : i18n.tv('Frontend.ExpertMode.SendPerMail', 'ORingConfiguratorImport')
})

const submitButtonText = computed(() => {
  return props.mode === 'download'
    ? i18n.tv('Frontend.ExpertMode.Download', 'ORingConfiguratorImport')
    : i18n.tv('Frontend.ExpertMode.SendPerMail', 'ORingConfiguratorImport')
})

const getForm = () => {
  return formData.value
}

// Computed properties for D365 submission
const formCaptureMarketingLanguage = computed(() => {
  return dynamicsCapture.getLanguageObject(i18n.locale.value)
})

const formCaptureCountry = computed(() => {
  return formData.value.country
})

const formCaptureDescription = computed(() => {
  // Only include user-provided design remarks
  return formData.value.designRemarks || ''
})

const formCaptureMetadata = computed(() => {
  const metadata: Record<string, any> = {}

  if (props.initialData?.designName) {
    metadata.ORingDesignName = props.initialData.designName
  }

  if (props.initialData?.parameters) {
    metadata.ORingParameters = props.initialData.parameters
  }

  return dynamicsCapture.buildDescriptionAppendix({
    formType: 'oRing',
    oring: {
      designName: props.initialData?.designName,
      parameters: props.initialData?.parameters
    }
  })
})

const handleSubmit = async () => {
  isSubmitting.value = true
  submissionStatus.value = null
  statusMessage.value = ''

  try {
    const submitData = {
      ...formData.value,
      name: [formData.value.firstName, formData.value.lastName].filter(v => v && v.trim()).join(' ').trim(),
      mode: props.mode
    }

    // Capture data to D365 if acceptTerms is checked
    if (formData.value.acceptTerms) {
      try {
        const captureData: Record<string, any> = {
          firstName: formData.value.firstName,
          lastName: formData.value.lastName,
          company: formData.value.company,
          email: formData.value.email,
          telephone: formData.value.telephone,
          country: formCaptureCountry.value,
          acceptTerms: formData.value.acceptTerms,
          description: formCaptureDescription.value,
          marketingLanguage: formCaptureMarketingLanguage.value,
          metadata: formCaptureMetadata.value
        }

        // Add industry fields only for logged-out users
        if (!isLoggedIn.value) {
          captureData.initialIndustry = formData.value.industryType
          captureData.leadMarket = formData.value.specificIndustry
        }

        // Add ERP fields for logged-in users
        if (isLoggedIn.value) {
          captureData.easyAccountNumber = companyNo.value
          captureData.easySalesOrganization = salesOrganization.value
        }

        await dynamicsCapture.captureFormData('oRing', captureData, i18n.locale.value, isLoggedIn.value)
      } catch (crmError) {
        // eslint-disable-next-line no-console
        console.warn('D365 capture failed:', crmError)
        // Continue with the main submission even if D365 fails
      }
    }

    if (props.onSubmit) {
      await props.onSubmit(submitData)
    } else {
      emit('submit', submitData)
    }

    const toast = app.$toast as any
    const successMessage = props.mode === 'download'
      ? i18n.tv('successDownload', 'ORingConfigurator') || 'Download successful'
      : i18n.tv('successSend', 'ORingConfigurator') || 'Email sent successfully'
    toast.success(successMessage)
    emit('close-pop-up')
  } catch (error) {
    const toast = app.$toast as any
    const errorMessage = i18n.tv('errorSubmission', 'ORingConfigurator') as string
    submissionStatus.value = 'error'
    statusMessage.value = errorMessage
    toast.error(errorMessage)
  } finally {
    isSubmitting.value = false
  }
}

const resetForm = () => {
  const freshPrefill = getExtendedPrefillData()
  formData.value = {
    firstName: freshPrefill.firstName,
    lastName: freshPrefill.lastName,
    email: freshPrefill.email,
    company: freshPrefill.company,
    telephone: freshPrefill.phone,
    country: freshPrefill.country || null,
    industryType: (freshPrefill.industryType ? Number(freshPrefill.industryType) : null) as number | null,
    specificIndustry: (freshPrefill.specificIndustry ? Number(freshPrefill.specificIndustry) : null) as number | null,
    leadMarket: freshPrefill.leadMarket || null,
    pdfLanguage: null,
    designRemarks: '',
    acceptTerms: false
  }
  submissionStatus.value = null
  statusMessage.value = ''
}

// Reset form when popup visibility changes
watch(
  () => props.show,
  (isVisible) => {
    if (isVisible) {
      if (!props.initialData) {
        resetForm()
      }
    } else {
      resetForm()
    }
  }
)

watch(
  () => props.initialData,
  (newData) => {
    if (newData && Object.keys(newData).length > 0) {
      const freshPrefill = getExtendedPrefillData()
      formData.value = {
        firstName: newData.firstName || freshPrefill.firstName,
        lastName: newData.lastName || freshPrefill.lastName,
        email: newData.email || freshPrefill.email,
        company: newData.company || freshPrefill.company,
        telephone: freshPrefill.phone,
        country: freshPrefill.country || null,
        industryType: (freshPrefill.industryType ? Number(freshPrefill.industryType) : null) as number | null,
        specificIndustry: (freshPrefill.specificIndustry ? Number(freshPrefill.specificIndustry) : null) as number | null,
        leadMarket: freshPrefill.leadMarket || null,
        pdfLanguage: newData.pdfLanguage || null,
        designRemarks: newData.designRemarks || '',
        acceptTerms: newData.acceptTerms || false
      }
    }
  },
  {immediate: true}
)
</script>

<style lang="scss">
.popup-oring-construction {
  &__header {
    h4 {
  margin: -.563rem 0 0;
    }
  }

  &__body {
    .construction-form {
      .form-field {
        .form-label {
          display: block;
          font-weight: $base-text-font-weight-light;
        }

        .form-input {
          width: 100%;

          textarea.k-textbox.k-textarea {
            min-height: 7.25rem;
            resize: vertical;
          }

          .input-wrapper textarea.k-textbox.k-textarea{
            min-height: 7.25rem;
            resize: vertical;
          }
        }

        &--horizontal {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          padding-bottom: .625rem;

          &.checkbox {
            padding-bottom: 0;
          }

          .form-label {
            flex: 0 0 11.25rem;
            margin-bottom: 0;
            margin-top: 0.75rem;
          }

          .form-input {
            flex: 1;

            &.textarea {
              min-height: 7.25rem;
            }
          }

          .enext-input--checkbox {
            flex-direction: column;
            align-items: flex-start;

            &__errormessage {
              min-height: auto;
            }
          }

          &.form-field--country {
            margin-top: 1rem;
          }
        }
      }

      .submission-status {
        display: flex;
        gap: .5rem;
        margin: 0 0 0.5rem;
        padding: .875rem .625rem;
        font-weight: $base-text-font-weight-light;

        &.success {
          border: 0.0625rem solid $color--input__border--ok;

          .icon.icon--svg {
            color: $color--input__border--ok;
          }
        }

        &.error {
          border: 0.0625rem solid $color--input__border--error;

          .icon.icon--svg {
            color: $color--input__border--error;
          }
        }

        .icon.icon--svg {
          width: 1.2rem;
          height: 1.2rem;
        }
      }

      .form-actions {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        span {
          font-weight: 300;
        }

        .submit-button {
          .indicatorReactiveButton {
            color: $color__white;
            margin-left: 0.5rem;
          }
        }
      }

       .checkbox {
          padding-top: 0.5rem;

          .k-checkbox-label {
            font-weight: 300;
          }
        }

      // ComboBox (country field) styling fixes
      .k-combobox {
        border: .0625rem solid $color--input__border;

        .k-input-button {
          .k-icon {
            min-height: auto;
            width: 2.5rem;
            background-color: transparent;
            color: $color__fst_gray__100;
            padding: .5rem;
          }
        }

        &.k-input:focus {
          border-color: $color--input__border;
        }
      }
    }
  }
}

@include breakpoint-down($md) {
  .popup-oring-construction {
    &__header {
      h4 {
        margin: 0 0 .5rem;
      }
    }

    .popup__content {
      width: 100%;
      padding: 1rem; // override large desktop padding
      box-sizing: border-box;
    }

    &__body {
      .construction-form {
        .form-field {
          &--horizontal {
            gap: 0.5rem;

            .form-label {
              flex: none;
              text-align: left;
              margin-bottom: 0.625rem;
              margin-top: 0.688rem;
              width: 7rem;
            }

            .form-input {
              width: 100%;
            }

            .enext-input--checkbox {
              flex-direction: column;
              align-items: flex-start;

              .checkbox-wrapper {
                align-items: flex-start;
              }
            }
          }
        }

        .checkbox {
          padding-top: 0.375rem;
          margin-bottom: 1.5rem;
        }

              // ComboBox (country field) styling fixes
      .k-combobox {
        border: .0625rem solid $color--input__border;

        .k-button {
          .k-icon {
            min-height: auto;
            width: 2.5rem;
            background-color: transparent;
            color: $color__fst_gray__100;
            padding: .5rem;
          }
        }

        &.k-input:focus {
          border-color: $color--input__border;
        }
      }
    }
  }
}
}
</style>
